import React from 'react';
import PropTypes from 'prop-types';
import TableRow from './TableRow.jsx';
import uiLocale from '../../../utils/UILocale.js';

export const BLUE_BOX = 'bluebox';
export const TAB = 'tab';

// eslint-disable-next-line react/prefer-stateless-function
export class PricePromiseTable extends React.Component {

  render() {
    const LEGAL_TEXT = uiLocale.getString('component.price-promise.legal');
    
    const { table, location } = this.props;
    const classNamePrefix = `price-promise-${location}-`;

    // Our translation system doesn't allow empty translations, so empty legal information text
    // contains '&nbsp;' instead.
    const hasLegalText = LEGAL_TEXT !== '&nbsp;';

    const showDelivery = table.some((row) => row.deliveryMessage);

    return !!table.length && (
      <div className={`${classNamePrefix}table-wrapper`}>
        <table className={`${classNamePrefix}table`}>
          <tbody>
            { table.map((row) =>
              (
                <TableRow
                  {...row}
                  key={row.competitorId}
                  showDelivery={showDelivery}
                />
              ))}
          </tbody>
        </table>

        { !!hasLegalText && (
          <span
            className={`${classNamePrefix}legal`}
            dangerouslySetInnerHTML={{ __html: LEGAL_TEXT }}
          />
        )}
      </div>
    );
  }
}

PricePromiseTable.propTypes = {
  table: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  location: PropTypes.oneOf([BLUE_BOX, TAB]).isRequired
};
